<template>
  <div class="empty">
    <div class="empty__icon" v-if="!hideIcon">
      <PolygonSvg icon="search" />
    </div>
    <div>{{ noResultText }} <!-- <i>detmanharsöktefter</i> --></div>
  </div>
</template>

<script>
export default {
  props: ['noResultText', 'hideIcon']
}
</script>

<style lang="scss" scoped>

.empty {
  display: flex;
  flex-direction: column;
  // align-items: center;
  // padding-top: 3rem;
  color: color(medium);

  p {
    // text-align: center;
  }

  i {
    display: block; // Always on new line
    font-style: normal;

    &::before,
    &::after {
      content: "\0022"; // Quotation marks
    }
  }
}

.empty__icon {
  height: 2.5rem;
  width: 2.5rem;

  .icon {
    fill: currentColor;
  }
}

</style>
